import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from '../../shared/services/firebase/auth.service';
import { OappService } from '../../shared/services/oapp.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

type UserFields = 'email' | 'password';
type FormErrors = { [u in UserFields]: string };

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public newUser = false;
  public user: firebase.User;
  public loginForm: FormGroup;
  public formErrors: FormErrors = {
    'email': '',
    'password': '',
  };
  public errorMessage: any;

  constructor(public authService: AuthService,
    private afauth: AngularFireAuth, private fb: FormBuilder, public oapp: OappService,private validatorsService:ValidatorsService,
    private router: Router) {
    this.loginForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      nit: [''],
    });
  }

  ngOnInit() {
  }

  // Login With Google
  loginGoogle() {
    this.authService.GoogleAuth();
  }

  // Login With Twitter
  loginTwitter(): void {
    this.authService.signInTwitter();
  }

  // Login With Facebook
  loginFacebook() {
    this.authService.signInFacebok();
  }

  // Simple Login
  login() {
    //arreglo para que permita logeearse con mayusculas o minuculas en el correo
    var email = this.loginForm.value['email'];
    var email = email.toLowerCase();
    //Arreglo inicio con nit
    var nit = this.loginForm.value['nit'].length>0?this.loginForm.value['nit']:this.oapp.netsolin_ini?.nit_principal;
    console.log('nit',nit);
    this.authService.SignIn(email, this.loginForm.value['password'], !!this.oapp.netsolin_ini, nit);
  }
  // Forget
  forgetpsw() {
    this.authService.ForgotPassword(this.loginForm.value['email']);
  }
  //ir a regsitrarse
  goToRegister() {
    this.router.navigate(['/auth/register']);
  }

}
